<script>
	import CustomCollapseCard from "src/components/CustomCollapseCard/CustomCollapseCard.svelte";
	import { Col, Row } from "@sveltestrap/sveltestrap";

	export let caseDetails = {};
	export let vehicleDetails = {};
</script>

<CustomCollapseCard
	isOpenDefault={true}
	title="Vehicle Information"
	customClass="mb-4"
>
	<div class="p-0">
		<Row>
			<Col class="col-4">
				<div class="description">Vehicle Number</div>
				<div class="value">{caseDetails.plateNo}</div>
			</Col>
			<Col class="col-4">
				<div class="description">Asset Owner</div>
				<div class="value">
					{vehicleDetails.assetOwnerName}
				</div>
			</Col>
		</Row>

		<hr class="divider" />

		<Row>
			<Col class="col-4">
				<div class="description">Make</div>
				<div class="value">
					{vehicleDetails.vehicleMakeName}
				</div>
			</Col>
			<Col class="col-4">
				<div class="description">Model</div>
				<div class="value">
					{vehicleDetails.vehicleModelName}
				</div>
			</Col>
		</Row>
	</div>
</CustomCollapseCard>
